import React from 'react';

import {Box, CircularProgress} from 'views/components';

const LoadingState = () => (
  <Box
    sx={{
      justifyContent: 'center',
      width: '100%',
      display: 'flex',
    }}
  >
    <CircularProgress />
  </Box>
);

export default React.memo(LoadingState);
